import IncentivesMarket from 'modules/incentivesMarket/pages/IncentivesMarket';
import { IncentivesMarketProvider } from '../contexts/IncentivesMarketContext';

const IncentivesMarketContainer = () => (
  <IncentivesMarketProvider>
    <IncentivesMarket />
  </IncentivesMarketProvider>
);

export default IncentivesMarketContainer;
